import { ICustomerFeature } from '../../model/api/featuremanagement';
import { ICustomerFeatureUpsert } from '../../model/api/featuremanagement/customer-feature-upsert';
import { getApi } from './api';

const getListByCustomerId = async (customerId: number) => {
  const url = `/feature/list?customerId=${customerId}`;
  const api = await getApi();
  return api.get<ICustomerFeature[]>(url).then((response) => response.data || []);
};

const save = async (customerFeature: ICustomerFeatureUpsert): Promise<ICustomerFeature> => {
  const api = await getApi();
  return api.post<ICustomerFeature>(`/feature`, customerFeature).then((response) => response.data);
};

export const featuresService = {
  getListByCustomerId,
  save,
};
